import { HeadsetMic } from "@mui/icons-material";
import { Info } from "lucide-react";
import React, { useState } from "react";

const RingBrowser = ({ setOpenConfigureSlotModal, route, setRoute, hasValidationError = false }) => {
    const [ringTarget, setRingTarget] = useState('ring_group')
  return (
    <div>
      <div className={`border-2 border-gray-200 rounded-xl p-6 space-y-4 shadow-sm ${hasValidationError ? "bg-red-50/80" : "bg-white"}`}>
        {/* Header */}
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center  gap-1">
            <HeadsetMic className="text-green-500" />
            <div>
              <h2 className="font-bold text-[18px]  text-gray-800">
                Ring User or Group in Browser
              </h2>

              <div className="text-[13px]">
                Ring a configured user or group{" "}
              </div>
            </div>
          </div>
          <button
            className=" text-blue-600 font-medium hover:underline text-[13px]"
            onClick={() => setOpenConfigureSlotModal(true)}
          >
            ↻ Change
          </button>
        </div>

        {/* Destination */}
        <div className="mb-4">
          <div className="flex items-center gap-1 mb-1">
            <span className="text-sm font-medium text-gray-700">
              Ring Target
            </span>
            <Info className="text-gray-400" fontSize="small" />
          </div>
          <select
            className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            defaultValue=""
            onChange={(e)=> {
                setRingTarget(e.target.value)
                setRoute((prev)=> ({
                    ...prev , 
                    ringTarget: e.target.value,
                }))
            }}
          >
            <option value="" disabled>
              Select a ring target
            </option>
            <option value="ring_group">Ring group</option>
            <option value="ring_user">Ring user</option>
          </select>
        </div>

        {/* Caller ID Setting */}
       {ringTarget == 'ring_group' && (
        <div className="mb-4">
          <div className="flex items-center gap-1 mb-1">
            <span className="text-sm font-medium text-gray-700">
              Ring Group
            </span>
            <Info className="text-gray-400" fontSize="small" />
          </div>
          <select
            className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            defaultValue="original"
            onChange={(e)=> {
                setRoute((prev)=> ({
                    ...prev , 
                    ringGroup: e.target.value,
                    ringUser:null
                }))
            }}
          >
            <option value="">Select Ring Group</option>
            <option value="group1">Ring Group</option>
          </select>
        </div>
       )}

       {ringTarget == 'ring_user' && (
        <div className="mb-4">
          <div className="flex items-center gap-1 mb-1">
            <span className="text-sm font-medium text-gray-700">
              Ring User
            </span>
            <Info className="text-gray-400" fontSize="small" />
          </div>
          <select
            className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
            defaultValue="original"
            onChange={(e)=> {
                setRoute((prev)=> ({
                    ...prev , 
                    ringTarget: null,
                    ringUser: e.target.value
                }))
            }}
          >
            <option value="">Select Ring User</option>
            <option value="user1">user 1</option>
          </select>
        </div>
       )}
      </div>
    </div>
  );
};

export default RingBrowser;
